"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9222],{

/***/ 33302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_FooterContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/containers/data/FooterData.tsx
const col1 = [{
  name: 'Chi siamo',
  title: 'Chi siamo',
  href: '/chi-siamo',
  target: '_self'
}, {
  name: 'Codice etico',
  title: 'Codice etico CarPlanner',
  href: 'https://static1.carplanner.com/website/docs/carplanner-codice-etico.pdf',
  target: '_blank'
}, {
  name: 'Auto elettriche',
  title: 'Noleggio auto elettriche a Lungo Termine',
  href: '/auto-elettriche/noleggio-a-lungo-termine',
  target: '_self'
}, {
  name: 'Auto in vendita',
  title: 'Ecco le nostre migliori offerte per i modelli auto disponibili',
  href: '/offerte-auto',
  target: '_self'
}, {
  name: 'Blog',
  title: 'News, prove, consigli e recensioni sul mondo delle Auto I Il blog di CarPlanner',
  href: 'https://blog.carplanner.com/',
  target: '_blank'
}, {
  name: 'I nostri marchi',
  title: 'Noleggio auto a Lungo Termine: vediamo i marchi migliori\n',
  href: '/noleggio-lungo-termine-marchi',
  target: '_self'
}, {
  name: 'Offerte Noleggio a Lungo Termine',
  title: 'Offerte Noleggio a Lungo Termine',
  href: '/noleggio-a-lungo-termine',
  target: '_self'
}, {
  name: 'Vantaggi del Noleggio',
  title: 'Vantaggi del Noleggio',
  href: '/noleggio-a-lungo-termine/vantaggi',
  target: '_self'
}, {
  name: 'FAQ',
  title: 'FAQ',
  href: '/noleggio-a-lungo-termine/faq',
  target: '_self'
}];
const col2 = [{
  name: 'Noleggio a Lungo Termine Senza Anticipo',
  title: 'Noleggio a Lungo Termine senza anticipo',
  href: '/noleggio-a-lungo-termine/senza-anticipo',
  target: '_self'
}, {
  name: 'Noleggio a Lungo Termine per Privati',
  title: 'Noleggio a Lungo Termine per Privati',
  href: '/noleggio-a-lungo-termine/offerte-privati',
  target: '_self'
}, {
  name: 'Noleggio a Lungo Termine per Aziende',
  title: 'Noleggio a Lungo Termine per Aziende',
  href: '/noleggio-a-lungo-termine/offerte-aziende',
  target: '_self'
}, {
  name: 'Noleggio a Lungo Termine BMW',
  title: 'Noleggio a Lungo Termine BMW',
  href: '/noleggio-a-lungo-termine/bmw',
  target: '_self'
}, {
  name: 'Noleggio a Lungo Termine Mercedes',
  title: 'Noleggio a Lungo Termine Mercedes',
  href: '/noleggio-a-lungo-termine/mercedes',
  target: '_self'
}, {
  name: 'Noleggio a Lungo Termine Smart',
  title: 'Noleggio a Lungo Termine Smart',
  href: '/noleggio-a-lungo-termine/smart',
  target: '_self'
}];
const col3 = [{
  name: 'Cookie Policy',
  title: 'Cookie Policy',
  href: '/policies/cookie',
  target: '_self'
}, {
  name: 'Privacy Policy',
  title: 'Privacy Policy',
  href: '/policies/privacy',
  target: '_self'
}, {
  name: 'Termini e Condizioni',
  title: 'Termini e Condizioni',
  href: '/policies/terms-and-conditions',
  target: '_self'
}, {
  name: 'Mappa del sito',
  title: 'Mappa del sito',
  href: '/mappa-del-sito',
  target: '_self'
}];

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/FooterContainer.tsx




const FooterComponent = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(6741), __webpack_require__.e(8719), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(8685)]).then(__webpack_require__.bind(__webpack_require__, 61937)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(61937)]
  }
});

const FooterContainer = () => /*#__PURE__*/(0,jsx_runtime.jsx)(FooterComponent, {
  col1: col1,
  col2: col2,
  col3: col3
});

/* harmony default export */ var containers_FooterContainer = (FooterContainer);

/***/ })

}]);